export default "__VITE_ASSET__BfMfScgA__"